module.exports = __webpack_public_path__ + "img/evaluacion-cerrar-black.e4f86169.svg";